import type {
  ConfirmGuestPaymentParams,
  CreateGuestOrderParams,
  GuestOrder,
} from '@/types/Order.types';
import slaydApi from './axiosInstance';

export const createGuestOrder = async (
  params: CreateGuestOrderParams
): Promise<GuestOrder> => {
  try {
    const response = await slaydApi.post<GuestOrder>(
      '/activity/guest-orders/',
      params
    );
    return response.data;
  } catch (error) {
    console.error('[OrdersService] createGuestOrder failed:', error);
    throw error;
  }
};

export interface ConfirmGuestPaymentResponse {
  orderId?: number;
  guestOrderId?: number;
  status: string;
}

export const confirmGuestPayment = async (
  guestOrderId: number,
  params: ConfirmGuestPaymentParams
): Promise<ConfirmGuestPaymentResponse> => {
  try {
    const response = await slaydApi.patch<ConfirmGuestPaymentResponse>(
      `/activity/guest-orders/${guestOrderId}/update-payment-status/`,
      params
    );
    return response.data;
  } catch (error) {
    console.error('[OrdersService] confirmGuestPayment failed:', error);
    throw error;
  }
};

export const fetchGuestOrderDetail = async (
  guestOrderId: string
): Promise<GuestOrder> => {
  try {
    const response = await slaydApi.get<GuestOrder>(
      `/activity/guest-orders/${guestOrderId}/`
    );
    return response.data;
  } catch (error) {
    console.error('[OrdersService] fetchGuestOrderDetail failed:', error);
    throw error;
  }
};
